"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketHelper = void 0;
exports.getAuctionInfo = getAuctionInfo;
exports.renderAsPremium = exports.premiumDomainAvailableForBuyNow = exports.isTaken = exports.isSafariBrowser = exports.isRestricted = exports.isReseller = exports.isRegPremium = exports.isPreReg = exports.isBuyNowAuction = exports.isBrowser = exports.isAvailable = exports.isAuction = exports.isAftermarketPremium = exports.is123Reg = exports.getSpinAvailabilityType = exports.getExactMatchAvailable = exports.getDomainTypes = exports.getDomainStatus = exports.getDomainMonthlyTerms = exports.getCookie = exports.getAvailLabel = void 0;
var _constants = require("./constants");
var _availabilityStatus = require("./constants/availabilityStatus");
var _availabilityLabel = require("./constants/availabilityLabel");
var _TccConstants = require("./constants/TccConstants");
var _searchStatus = require("./constants/searchStatus");
var _auctionTypes = require("./constants/auctionTypes");
/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable complexity */

const NON_RESELLER_PLID = 1;
const RESELLER_123_REG_PLID = 587240;
const isAftermarketPremium = domain => {
  return domain.Inventory === _availabilityStatus.AvailabilityStatus.Premium;
};
exports.isAftermarketPremium = isAftermarketPremium;
const isRegPremium = domain => {
  return domain.Inventory === _availabilityStatus.AvailabilityStatus.RegPremium;
};
exports.isRegPremium = isRegPremium;
const isAuction = domain => {
  return domain.Inventory === _availabilityStatus.AvailabilityStatus.Auction;
};
exports.isAuction = isAuction;
const isRestricted = domain => {
  return Boolean(domain.IsRestricted);
};
exports.isRestricted = isRestricted;
const isPreReg = domain => {
  return domain.AvailabilityLabel === _availabilityStatus.AvailabilityStatus.PreReg;
};
exports.isPreReg = isPreReg;
const isTaken = domain => {
  return domain.AvailabilityLabel === _availabilityStatus.AvailabilityStatus.Taken;
};
exports.isTaken = isTaken;
const isAvailable = domain => {
  return domain.AvailabilityLabel === _availabilityStatus.AvailabilityStatus.Available;
};
exports.isAvailable = isAvailable;
const getAvailLabel = label => {
  switch (label) {
    case _availabilityStatus.AvailabilityStatus.Available:
      return _availabilityLabel.AVAILABILITY_LABEL.Available;
    case _availabilityStatus.AvailabilityStatus.PreReg:
      return _availabilityLabel.AVAILABILITY_LABEL.PreReg;
    case _availabilityStatus.AvailabilityStatus.Premium:
    case _availabilityStatus.AvailabilityStatus.RegPremium:
    case _availabilityStatus.AvailabilityStatus.Auction:
      return _availabilityLabel.AVAILABILITY_LABEL.Premium;
    case _availabilityStatus.AvailabilityStatus.Taken:
    case _availabilityStatus.AvailabilityStatus.Excluded:
    case _availabilityStatus.AvailabilityStatus.Reserved:
      return _availabilityLabel.AVAILABILITY_LABEL.Taken;
    default:
      return _availabilityLabel.AVAILABILITY_LABEL.Error;
  }
};
exports.getAvailLabel = getAvailLabel;
const getDomainStatus = ({
  isAftermarketPremiumDomain,
  isAuctionDomain,
  isRegPremiumDomain
}) => {
  if (isAftermarketPremiumDomain) {
    return 'premium';
  }
  if (isAuctionDomain) {
    return 'auction';
  }
  if (isRegPremiumDomain) {
    return 'registry_premium';
  }
  return 'available_for_registration';
};
exports.getDomainStatus = getDomainStatus;
const renderAsPremium = domain => {
  return isAftermarketPremium(domain) || isRegPremium(domain) || isAuction(domain);
};
exports.renderAsPremium = renderAsPremium;
const isReseller = plid => {
  return plid && plid.toString() !== NON_RESELLER_PLID.toString();
};
exports.isReseller = isReseller;
const is123Reg = plid => {
  return plid && plid.toString() === RESELLER_123_REG_PLID.toString();
};
exports.is123Reg = is123Reg;
const MarketHelper = exports.MarketHelper = {
  isPhoneHiddenMarket(market) {
    return market === 'zh-SG';
  },
  marketDir() {
    return window.ux?.eldorado?.data?.dir || 'ltr';
  },
  isRtlMarket() {
    return this.marketDir() === 'rtl';
  }
};
const getDomainTypes = domain => ({
  isAftermarketPremium: isAftermarketPremium(domain),
  isRegPremium: isRegPremium(domain),
  isAuction: isAuction(domain),
  renderAsPremium: renderAsPremium(domain)
});
exports.getDomainTypes = getDomainTypes;
const isBrowser = () => {
  return !!(typeof window !== 'undefined' && typeof document !== 'undefined');
};
exports.isBrowser = isBrowser;
const getCookie = name => {
  // check if it's browser or server side. Must do this tertiary or the variable gets hoisted above the if check.
  const match = isBrowser() ? document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)')) : false;
  return match ? match[2] : '';
};

/**
 * @description Returns spin availability Type.
 * @param {object} spin spin object.
 * @returns {string} availability type
 */
exports.getCookie = getCookie;
const getSpinAvailabilityType = spin => {
  if (isAftermarketPremium(spin) || isAuction(spin)) {
    return _TccConstants.AVAILABILITY_TYPES.availableAftermarketPremium;
  } else if (isRegPremium(spin)) {
    return _TccConstants.AVAILABILITY_TYPES.availablePrimaryRegPremiumTier;
  }
  return _TccConstants.AVAILABILITY_TYPES.availablePrimaryBaseTier;
};
exports.getSpinAvailabilityType = getSpinAvailabilityType;
const isSafariBrowser = () => {
  return window?.navigator?.userAgent?.indexOf('Safari') > -1 && window?.navigator?.userAgent?.indexOf('Chrome') <= -1;
};
exports.isSafariBrowser = isSafariBrowser;
const getUserLoggedIn = isUserLoggedIn => {
  if (!isUserLoggedIn) {
    const idpData = JSON.parse(window.decodeURIComponent(getCookie('info_idp')) || '{}');
    const mergedIdpData = {
      ...idpData,
      ...(idpData?.[idpData.auth] || {})
    };
    const {
      info_shopperId = ''
    } = mergedIdpData;
    return !!info_shopperId;
  }
  return isUserLoggedIn;
};

/**
 * @description Determines monthly terms to use for a product based on term overrides and other term length configurations
 * @param {object} product product that includes domain info
 * @param {object} product.domain domain info
 * @param {object} product.priceInfo product's price info
 * @param {Array<Number>} product.priceInfo.SupportedYears array of supported years for term length
 * @param {number} product.priceInfo.PromoRegLengthFlag PromoRegLengthFlag value
 * @param {number} tmskeyTerms [optional] Term length configured via tmskey config (in months).
 * @param {boolean} isUserLoggedIn [optional] is it new or repeat shopper
 * @param {number} domainTermsOverride [optional] term length override (in months). It is any term override that should take priority over any other term configuration
 * @param {number} defaultDomainTerms [optional] default term length configuration (in months). Term to use by default
 * @returns {{Fqdn: string, term: number}} domain and monthly term to use
 */
// eslint-disable-next-line complexity
const getDomainMonthlyTerms = ({
  product = {},
  tmskeyTerms,
  isUserLoggedIn,
  domainTermsOverride,
  defaultDomainTerms,
  skipSupportedYearsCheck
} = {}) => {
  const {
    domain,
    priceInfo = {}
  } = product;
  const supportedYears = priceInfo.SupportedYears;
  const promoRegLengthTerms = priceInfo.PromoRegLengthFlag > 1 && priceInfo.PromoRegLengthFlag * 12;
  let domainMonthlyTerms = domainTermsOverride || tmskeyTerms || promoRegLengthTerms || defaultDomainTerms;
  const bypassSupportedYearsCheck = tmskeyTerms && domainMonthlyTerms === tmskeyTerms || !supportedYears?.length || skipSupportedYearsCheck;
  if (!domainMonthlyTerms) {
    domainMonthlyTerms = getUserLoggedIn(isUserLoggedIn) ? _constants.REPEAT_USER_MONTHLY_TERM : _constants.NEW_USER_MONTHLY_TERM;
  }
  if (!bypassSupportedYearsCheck && supportedYears.findIndex(year => year === domainMonthlyTerms / 12) === -1) {
    domainMonthlyTerms = supportedYears[0] * 12;
  }
  return {
    Fqdn: domain?.Fqdn,
    term: domainMonthlyTerms
  };
};
exports.getDomainMonthlyTerms = getDomainMonthlyTerms;
function getAuctionInfo(auctionTypeId, auctionTypeIdsStraightToCart = []) {
  const addStraightToCart = auctionTypeIdsStraightToCart.includes(auctionTypeId);
  // For all ids, refer to https://godaddy-corp.atlassian.net/wiki/spaces/AN/pages/83559972/Aftermarket+Business+Requirements
  if (_auctionTypes.AuctionTypes.Biddable.includes(auctionTypeId)) {
    return {
      infoTextId: 'domain.available.info.bid',
      buyNowTextId: 'bid',
      showMakeOffer: !addStraightToCart,
      makeOfferTextId: 'placeBid'
    };
  } else if (_auctionTypes.AuctionTypes.BuyItNowNonFastTransfer.includes(auctionTypeId)) {
    return {
      infoTextId: 'domain.available.info.buyItNow',
      buyNowTextId: 'buyItNow',
      showMakeOffer: false
    };
  } else if (_auctionTypes.AuctionTypes.BuyItNowOfferCounterOffer.includes(auctionTypeId)) {
    return {
      infoTextId: 'domain.available.info.getIt',
      buyNowTextId: 'getIt',
      showMakeOffer: !addStraightToCart,
      makeOfferTextId: 'getIt'
    };
  } else if (_auctionTypes.AuctionTypes.BuyItNowNonCloseout.includes(auctionTypeId)) {
    return {
      infoTextId: 'domain.available.info.buyItNow',
      buyNowTextId: 'buyItNow',
      showMakeOffer: false
    };
  } else if (_auctionTypes.AuctionTypes.MemberOfferCounterOffer.includes(auctionTypeId)) {
    return {
      infoTextId: 'domain.available.info.makeOffer',
      buyNowTextId: 'makeOffer',
      showMakeOffer: !addStraightToCart,
      makeOfferTextId: 'makeOffer'
    };
  }
  return {};
}
const isBuyNowAuction = domain => {
  const id = domain?.AuctionTypeId || 0;
  return _auctionTypes.AuctionTypes.BuyItNowNonFastTransfer.includes(id) || _auctionTypes.AuctionTypes.BuyItNowNonCloseout.includes(id);
};
exports.isBuyNowAuction = isBuyNowAuction;
const premiumDomainAvailableForBuyNow = domain => {
  const isDomainAftermarketPremium = isAftermarketPremium(domain);
  const isDomainRegPremium = isRegPremium(domain);
  const isDomainAuction = isAuction(domain);
  return isDomainAftermarketPremium || isDomainRegPremium || isDomainAuction && isBuyNowAuction(domain);
};
exports.premiumDomainAvailableForBuyNow = premiumDomainAvailableForBuyNow;
const getExactMatchAvailable = (exactResult, exactResultProduct, smartExactResult) => {
  const exactMatchDomain = exactResult;
  const priceInfo = exactResultProduct.PriceInfo;
  const product = exactResultProduct;
  const productContent = exactResultProduct.Content;
  const smartExactMatchDomain = smartExactResult?.ExactMatchDomain;
  const smartPriceInfo = smartExactResult?.Products?.[0]?.PriceInfo;
  const smartProduct = smartExactResult?.Products?.[0];

  // getAvailLabel can group several domain labels into one (ie premium, regpremium, auction = premium)
  const exactMatchAvailability = getAvailLabel(exactMatchDomain?.AvailabilityLabel);
  const isExactMatchDomainAvailable = exactMatchAvailability === _searchStatus.SEARCH_STATUS.Available;
  const isExactMatchDomainTaken = exactMatchAvailability === _searchStatus.SEARCH_STATUS.Taken;
  const isAftermarketPremiumDomain = isAftermarketPremium(exactMatchDomain);
  const isRegPremiumDomain = isRegPremium(exactMatchDomain);
  const isAuctionDomain = isAuction(exactMatchDomain);
  const isPreRegDomain = isPreReg(exactMatchDomain);
  const isSmartExactMatchDomainAvailable = getAvailLabel(smartExactMatchDomain?.AvailabilityLabel) === _searchStatus.SEARCH_STATUS.Available;
  const showSmartExactMatchDomain = !isExactMatchDomainAvailable && isExactMatchDomainTaken && isSmartExactMatchDomainAvailable;
  return {
    showSmartExactMatchDomain,
    isAvailable: isExactMatchDomainAvailable,
    isTaken: isExactMatchDomainTaken,
    isAftermarketPremium: isAftermarketPremiumDomain,
    isRegPremium: isRegPremiumDomain,
    isAuction: isAuctionDomain,
    isPreReg: isPreRegDomain,
    exactMatchDomain: showSmartExactMatchDomain ? smartExactMatchDomain : exactMatchDomain,
    priceInfo: showSmartExactMatchDomain ? smartPriceInfo : priceInfo,
    product: showSmartExactMatchDomain ? smartProduct : product,
    productContent
  };
};
exports.getExactMatchAvailable = getExactMatchAvailable;